module.exports = __webpack_public_path__ + "statics/img/section_top.png";